import { normalizeHostname } from "./host_root_landing";

/** Dedicated XO Call product fronts: `/` renders CallLanding (see `main.tsx`). */
const CALL_DEDICATED_ROOT_HOSTS = new Set([
  "call.21xo.com",
  "www.call.21xo.com",
  "call.21xo.to",
  "www.call.21xo.to",
  "xo-call.com",
  "www.xo-call.com",
]);

export function isCallDedicatedProductRootHost(hostname: string): boolean {
  return CALL_DEDICATED_ROOT_HOSTS.has(normalizeHostname(hostname));
}
